import React from 'react';
import './Banner.css';

class Banner extends React.Component {
  render() {
    return (
      <div id="headerContainer">
        <h1>Help Is Here</h1>
        <h5>Resources for NY Residents affected by COVID-19</h5>
      </div>
    )
  }
}

export default Banner;